export default {"src":"/_next/static/media/plan-analyzing.aa4da631.svg","height":240,"width":536,"blurWidth":0,"blurHeight":0};